import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';

export class AdvisorService {
  static getAll = async (data) => {
    const { limit, offset } = data;
    return await api.get(API_URLS.ADVISOR_V3, {
      params: { limit, offset, order: 'DESC' },
    });
  };

  static getUsersForAdvisor = async () => {
    return await api.get(API_URLS.USER_SEARCH_V3);
  };

  static getAwaitApprove = async (data) => {
    const { limit, offset, status } = data;
    return await api.get(API_URLS.ADVISORS_V3, {
      params: { limit, offset, status },
    });
  };

  static activate = async (id) => {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}/activate`);
  };

  static deactivate = async (id) => {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}/deactivate`);
  };

  static create = async (data) => {
    return await api.post(API_URLS.ADVISORS_V3, data);
  };

  static update = async ({ data, id }) => {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}`, data);
  };

  static reinvite = async (id) => {
    return await api.put(API_URLS.ADVISOR_REINVITE, { userID: id });
  };

  static delete = async (id) => {
    return await api.delete(`${API_URLS.ADVISOR}/${id}`);
  };
}
